export default __webpack_public_path__ + "static/indoor0-4679ee093dde7797b14a8ecd184464d4.webp";